import Header from "./Header";
import Footer from "./Footer";
import CTASection from "./CTASection";
import "../styles/header/header.css";

export default function PolicyPage() {
  return (
    <div className="main">
      <Header />
      <div
        className="policy-container"
        style={{
          maxWidth: "800px",
          margin: "0 auto",
          padding: "2rem",
          fontSize: "1.1rem", // increased font size
          lineHeight: "1.8", // better line spacing
        }}
      >
        <h1
          style={{
            fontSize: "2.2rem", // slightly larger heading
            fontWeight: "bold",
            marginBottom: "1.5rem",
          }}
        >
          Privacy Policy
        </h1>

        <p>This is the official Government Form website.</p>

        <p>
          <strong>Data We Collect and How We Use It</strong>
          <br />
          When you simply browse this website, we don't collect data that
          identifies you personally. We use technologies, like cookies, to
          understand how people use our site so we can improve it. This
          information helps us customize your experience and may be shared with
          our trusted government partners to enhance your experience on their
          websites as well.
        </p>

        <p>
          These technologies do not capture any personal data about you.
          Instead, they focus on your browsing patterns on this site and others
          you visit after leaving.
        </p>

        <p>
          <strong>Your Choices About Cookies</strong>
          <br />
          You can choose to accept or decline cookies. Most web browsers
          automatically accept cookies, but you can change your browser settings
          to decline them if you prefer. Just be aware that this might prevent
          you from using all the features of the website.
        </p>

        <p>
          <strong>When You Provide Personal Data</strong>
          <br />
          When you provide us with personal information, we may share that data
          with other government agencies to serve you as efficiently as
          possible, unless a law prohibits us from doing so.
        </p>

        <p>
          We will not share your personal data with non-government entities
          unless they are authorized to perform a specific government service on
          our behalf.
        </p>

        <p>
          We may also show you data you've previously submitted to us or another
          government agency. This saves you time by not having to re-enter
          information you've already provided. If any of this data is outdated,
          please be sure to update it.
        </p>

        <p>
          <strong>How We Protect Your Data</strong>
          <br />
          To protect your personal data, we secure all electronic storage and
          transmission using appropriate security technologies.
        </p>

        <p>
          If you have questions, feedback, or need more information about the
          data you've provided to us in the past, please contact us at{" "}
          <a href="mailto:info@ai.gov.kh">info@ai.gov.kh</a>.
        </p>
      </div>
      <CTASection />
      <Footer hideFooter={false} />
    </div>
  );
}
